import { useDispatch, useSelector } from 'react-redux';

import type { AppDispatch, RootState } from './index.js';

/** Typed wrappers, so components never reach for `any`. */
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
